import "./App.css";
import { Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';

import Landing from "./screens/Landing";
import Admin from "./screens/Admin";
import AdminLogin from "./screens/AdminLogin";
import NotAuthorized from './screens/NotAuthorized';
import Login from './screens/Login';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from "./components/AuthContext";
import Signup from "./screens/Signup";
import Logout from "./screens/Logout";
import Verify from "./screens/Verify";
import ForgotPassword from "./screens/ForgotPassword";

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/adminlogin" element={<Login />} />
        <Route path="/not-authorized" element={<NotAuthorized />} />
        <Route path="/" element={<Landing />} />
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          }
        >
          
            <Route path="verify" element={<ProtectedRoute><Verify/></ProtectedRoute>} />
          

        </Route>
        <Route path="/adminsignup" element={<Signup />} />
        
        <Route path="/logout" element={<Logout /> } /> {/* Add the /logout route */}
        <Route path="/forgotpassword" element={<ForgotPassword/>} /> 
      </Routes>
    </AuthProvider>
  );
}

export default App;
